/**
 * Renders the filters based on the provided data.
 * Term counts, pagination, and post type counts are updated.
 *
 * @param {Object} feed - The feed data to render.
 */
export default (feed) => {
	document
		.querySelectorAll('.form-check-label .js-gsfc-term-count')
		.forEach((label) => {
			const termId = Number(label.dataset.termId);
			const checkbox = document.querySelector(
				`input.js-gsfc-filter-tax-checkbox[value="${termId}"]`
			);
			if (checkbox) {
				checkbox.disabled = true;
			}
			label.innerHTML = '(0)';
		});

	const itemsOnPage = document.querySelectorAll('.js-gsfc-feed .row').length;
	if (itemsOnPage > 0) {
		const start = feed.current_page * feed.per_page + 1 - feed.per_page;
		const end = start - 1 + itemsOnPage;
		document.querySelector('.js-gsfc-posts-start').innerHTML =
			Number(start);
		document.querySelector('.js-gsfc-posts-end').innerHTML = Number(end);
		document.querySelector('.js-gsfc-posts-total').innerHTML = Number(
			feed.total_posts
		);
		document.querySelector('.js-gsfc-posts-pagination-desc').style.display =
			'block';
	} else {
		document.querySelector('.js-gsfc-posts-pagination-desc').style.display =
			'none';
	}

	if (document.querySelectorAll('.js-gsfc-filter-post-type').length > 0) {
		document
			.querySelectorAll('.js-gsfc-filter-post-type')
			.forEach((postType) => {
				const type = postType.dataset.postType;
				const count = Number(feed.post_types[type]) || 0;
				if (count > 0) {
					postType.parentElement.querySelector('span').innerHTML =
						`(${count})`;
					postType.parentElement.style.display = 'block';
				} else {
					postType.parentElement.style.display = 'none';
				}
			});

		const totalPostTypesSpan = document
			.querySelector('.js-gsfc-filter-post-type-all')
			.parentElement.querySelector('span');
		if (totalPostTypesSpan) {
			totalPostTypesSpan.innerHTML = `(${Number(feed.total_post_types) ? Number(feed.total_post_types) : 0})`;
			totalPostTypesSpan.parentElement.style.display = 'block';
		}
	}

	//Update the date from and date to inputs #gsfc-date-filter-to and #gsfc-date-filter-from
	const dateFrom = document.querySelector('#gsfc-date-filter-from');
	const dateTo = document.querySelector('#gsfc-date-filter-to');
	if (dateFrom) {
		dateFrom.value = global.filters.date_range_from;
	}
	if (dateTo) {
		dateTo.value = global.filters.date_range_to;
	}
};
